module.exports = __webpack_public_path__ + "static/tired-881ce5d336a373b56ab549bb3159f52f.svg";